/* Automatically generated by './build/bin/build-entry.js' */
import iView from 'iview';

// import './themes/wuwei/index.less'

import Button from './components/button/index.js'
import Chart from './components/chart/index.js'
import Checkbox from './components/checkbox/index.js'
import G2 from './components/g2/index.js'
import Layout from './components/layout/index.js'
import Radio from './components/radio/index.js'
import Select from './components/select/index.js'

const components = [
  Button,
  Chart,
  Checkbox,
  G2,
  Layout,
  Radio,
  Select
]

const install = function (Vue, opts = {}) {
  components.forEach(component => {
    if (component) Vue.component(component.name, component)
  })
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '0.1.0',
  /* i18n: locale.i18n */
  install,
  Button,
  Chart,
  Checkbox,
  G2,
  Layout,
  Radio,
  Select
}



// WEBPACK FOOTER //
// ./packages/index.js